export { HomePage } from "../components/pages/home";
export { SectionPage } from "../components/pages/section/";
export { TagPage } from "../components/pages/tag";
export { SearchPage } from "../components/pages/search";
export { CatalogPage } from "../components/pages/catalog";
export { HomePagePreview } from "../components/pages/home-preview";
export { NotFoundPage } from "../components/pages/not-found";
